import React from 'react';
import './Poll.scss';

function Q1AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      Approximately 1 in 3 adults with atopic dermatitis have moderate-to-severe disease.
    </p>
  );
}

export default Q1AnswerCopy;
